//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EventEmitter, Injectable, Output, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class ToastService {

  @Output() toastAdded: EventEmitter<any> = new EventEmitter<any>();
  
  public toasts: any[]=[];
    
  constructor(
  ) { }

  public show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
    this.toastAdded.emit();
  }

  public remove(toast: any) {
    this.toasts=this.toasts.filter(t => t !== toast);
  }

  public removeAll() {
    this.toasts=[];
  }

  public removeWhereContains(searchWord: string, breakOnFirstFound: boolean=true) {
    let _break: boolean=false;

    this.toasts.forEach(x => {
      if (!_break) {
        if (typeof x.textOrTpl==="string" && x.textOrTpl.includes(searchWord)) {
          this.remove(x);
          
          if (breakOnFirstFound)
            _break=true;
        }
      }
    });
  }
}
